import React from 'react';

import { Text } from '../Text';


export const Loader = (props) => {
    return <Text info role="alert">Trwa inicjalizacja danych...</Text>
}
